var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"passwordWait",attrs:{"heading":"メール送信完了"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('Body',{attrs:{"priority":"tertiary"}},[_vm._v(" 入力したメールを使用しているメールアプリをご確認ください。 ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }